import React from 'react';
import styled from 'styled-components';
import { sanitize } from 'isomorphic-dompurify';

import { toRem } from '@front/common/src/utils/styles';

import { textStyle, TextStyleProps } from '../base-text/base-text';

const Container = styled.div<TextStyleProps>`
  p,
  li,
  span {
    margin: 0;
    ${textStyle}
  }

  b {
    padding-top: ${toRem(10)};
  }

  ul {
    margin-bottom: ${toRem(10)};
  }
`;

export type SanitizedHTMLProps = {
  className?: string;
  html: string;
  lineHeight?: number;
};

/**
 * Sets inner HTML after sanitization.
 * @see file html-view-style.js in mobile-ui.
 */
const SanitizedHTML = ({ className, html, lineHeight }: SanitizedHTMLProps) => (
  <Container className={className} dangerouslySetInnerHTML={{ __html: sanitize(html) }} $lineHeight={lineHeight} />
);

export default SanitizedHTML;
